module.exports = __webpack_public_path__ + "static/media/icon-logout.118016be.svg";